// extracted by mini-css-extract-plugin
module.exports = {"root":"SignaturePlugin_root__LeLVq","signature":"SignaturePlugin_signature__vnNEq"};